import type { GiftPassBundle } from '@bonsai/shared';

import { GiftPassBundlesTableRow } from './GiftPassBundlesTableRow';

export interface GiftPassBundlesTableProps {
  bundles: readonly GiftPassBundle[];
  canOpen: boolean;
}

export function GiftPassBundlesTable({ bundles, canOpen }: GiftPassBundlesTableProps) {
  return (
    <table className="nb-tbl" aria-label="Bundles" style={{ minWidth: 820 }}>
      <thead>
        <tr>
          <th scope="col" style={{ paddingLeft: 18 }}>
            Bundle
          </th>
          <th scope="col">Passes</th>
          <th scope="col">Discount</th>
          <th scope="col">Tags</th>
          <th scope="col">Status</th>
          <th scope="col" style={{ paddingRight: 18 }}>
            Updated
          </th>
        </tr>
      </thead>
      <tbody>
        {bundles.map((bundle) => (
          <GiftPassBundlesTableRow key={bundle.id} bundle={bundle} canOpen={canOpen} />
        ))}
      </tbody>
    </table>
  );
}
